import { render } from "./ContactsModal.vue?vue&type=template&id=423e178c"
import script from "./ContactsModal.vue?vue&type=script&lang=js"
export * from "./ContactsModal.vue?vue&type=script&lang=js"

import "./ContactsModal.vue?vue&type=style&index=0&id=423e178c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__